import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPills } from "@fortawesome/free-solid-svg-icons";

import ModalSintomas from "./ModalSintomas";
import Tabla from "./Tabla";

const SintomasHomeopatia = () => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <Card>
      <Card.Header
        style={{
          backgroundColor: "#F5E6D3",
          color: "#5E8C5A",
          fontWeight: "bold",
        }}
        as="h3"
      >
        Síntomas Homeopatía <FontAwesomeIcon icon={faPills} />
      </Card.Header>
      <Card.Body>
        <Button
          className="mb-3"
          style={{
            backgroundColor: "#7FC18E",
            borderColor: "#7FC18E",
            color: "#FFFFFF",
          }}
          onClick={() => setModalShow(true)}
        >
          Ver listado de síntomas de Homeopatía
        </Button>
        <Tabla />
      </Card.Body>
      {modalShow && (
        <ModalSintomas show={modalShow} onHide={() => setModalShow(false)} />
      )}
    </Card>
  );
};

export default SintomasHomeopatia;
